import axios from "axios";
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgVideo from 'lightgallery/plugins/video'
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
const $ = window.jQuery;
const $window = window.$window || $( window );

export default {
  init() {
    // JavaScript to be fired on the home page
    console.log('single Plan');
    lightGallery(document.getElementById('plan-video'), {
      plugins: [lgVideo],
    });

    Fancybox.bind('[data-fancybox="elevation_gallery"]', {
      Image: {
        zoom: true,
      },
    });

    Fancybox.bind('[data-fancybox="gallery_lightbox_plans"]', {
      Image: {
        zoom: true,
      },
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



